import RaporKosulGrupEntity from "@/entity/RaporKosulGrupEntity";

export class RaporEntity {
    alanlar !: [];
    id: number | null = null;
    isim: string | null = null;
    standart_mi!:boolean
    rapor_alanlari: Array<number> = [1];    // Default olarak kart numarasının seçili gelmesini sağlar
    rapor_secilen_kosullar: RaporKosulGrupEntity = new RaporKosulGrupEntity();
}